import { render, staticRenderFns } from "./UmsLocationEditor.vue?vue&type=template&id=b79f3e30&"
import script from "./UmsLocationEditor.vue?vue&type=script&lang=js&"
export * from "./UmsLocationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports